<template>
  <a :href="item.url" class="document-library-card">
    <div v-if="item.image && item.image.url" class="document-library-card__image-frame">
      <img class="document-library-card__image" width="84" height="117" :src="item.image.url" :alt="item.image.alt" />
    </div>
    <div class="document-library-card__content">
      <div class="document-library-card__tags" v-if="item.tags.length">
          <div v-for="item in item.tags" :key="item">{{ item }}</div> 
      </div>
      <h3 class="document-library-card__heading">{{ item.heading }}</h3>
      <div class="document-library-card__button-holder">
        <div class="c-button c-button--small c-button--brand c-button--font-heading c-button--bg-color-brand-nine">
          <svg class="c-button__icon c-button__icon--alt" aria-hidden="true" focusable="false">
            <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#download"></use>
          </svg>
          <span class="c-button__inner">{{item.document.type}} - {{item.document.size}}</span>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    props: {
      item: {
        type: Object,
        required: true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/document-library/DocumentLibraryCard.vue